import humps from 'humps'

import { porticoApi } from 'store/porticoApi'
import { TPermission } from 'types/permissions'
import { TCreateRole, TRole, TRoleWithPermissions, TUpdateRole } from 'types/roles'
import { createPermissionsParam } from 'utils/rolesPermissions/createPermissionsParam'
import { transfromRolesToRolesWithPermissions } from 'utils/rolesPermissions/transformRolesToRolestWithPermissions'

type TRoleResponse = {
  userRoles: TRole[]
}

type TPermissionResponse = {
  permissions: TPermission[]
}

const roles = porticoApi.injectEndpoints({
  endpoints: (builder) => ({
    getRoles: builder.query<TRoleWithPermissions[], void>({
      async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
        const userRoles = await fetchWithBQ('operator/user_roles')
        const userRolesData = userRoles?.data as TRoleResponse
        const userRolesResult: TRole[] = userRolesData?.userRoles
        const userRolesUuids = userRolesResult?.map(({ uuid }) => uuid)

        const permissionsParam = createPermissionsParam(userRolesUuids)
        const permissions = await fetchWithBQ(`operator/permissions?${permissionsParam}`)
        const permissionsData = permissions?.data as TPermissionResponse
        const permissionsResult: TPermission[] = permissionsData?.permissions

        const rolesWithPermissions = transfromRolesToRolesWithPermissions(
          userRolesResult,
          permissionsResult
        )

        return { data: rolesWithPermissions }
      },
      providesTags: (result) =>
        result ? [...result.map(({ uuid }) => ({ type: 'Roles' as const, id: uuid }))] : ['Roles'],
    }),
    createRole: builder.mutation<TRole, TCreateRole>({
      query: (body) => ({
        url: 'operator/user_roles',
        method: 'POST',
        body: humps.decamelizeKeys({ user_roles: [body] }),
      }),
      invalidatesTags: ['Roles'],
    }),
    updateRole: builder.mutation<TRole, TUpdateRole>({
      query: (body) => ({
        url: 'operator/user_roles',
        method: 'PUT',
        body: humps.decamelizeKeys({ user_roles: body }),
      }),
      invalidatesTags: ['Roles'],
    }),
  }),
})

export const { useGetRolesQuery, useCreateRoleMutation, useUpdateRoleMutation } = roles
